'use client';

import React from 'react';
import styled from 'styled-components';

const ShippingBanner = () => {
  return (
    <BannerWrapper>
      <BannerContent>
        <BannerText>
          Free Shipping on Orders $100+ · Use Code <CodeHighlight>FREESHIPPING2026</CodeHighlight>
        </BannerText>
      </BannerContent>
    </BannerWrapper>
  );
};

export default ShippingBanner;

const BannerWrapper = styled.div`
  background: #1a1a1a;
  color: #fff;
  width: 100%;
  height: 45px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  box-shadow: none;
  border-bottom: 1px solid rgba(0, 173, 35, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  contain: layout style paint;

  @media (max-width: 767px) {
    height: 55px;
  }
`;

const BannerContent = styled.div`
  text-align: center;
  width: 100%;
  padding: 0 10%;
`;

const BannerText = styled.div`
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.3px;
  line-height: 1;
  color: #e0e0e0;

  @media (max-width: 767px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const CodeHighlight = styled.span`
  display: inline-block;
  background-color: rgba(0, 173, 35, 0.15);
  padding: 2px 8px;
  border: 1px solid rgba(0, 173, 35, 0.4);
  border-radius: 3px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #00ad23;
  margin-left: 4px;

  @media (max-width: 767px) {
    padding: 2px 6px;
  }
`;
